// @flow

import { DEPLOYMENT_ENVIRONMENT } from 'shared/config';
import { logger } from 'shared/utils/logger';

import * as honeybadger from './honeybadger';
import type { Context } from './types';

export const initErrorTracking = () => {
  if (!DEPLOYMENT_ENVIRONMENT || DEPLOYMENT_ENVIRONMENT === 'local') return;

  honeybadger.init();
};

export const captureException = (err: Error, errorInfo: any) => {
  honeybadger.captureException(err, errorInfo);
  logger.error(err, errorInfo);
};

export const setContext = (context: Context) => {
  honeybadger.setContext(context);
};
